import Commons from '../../../../Services/Common/Common';
const encryptWithDebug = (label, raw) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[POL_BASIC_01][encrypt-before] ${label}:`, raw);
  }
  return Commons.EncryptAES(raw);
};
export const TRA_CUSTOM_05_Schema = {
  fields: {
    grid: {
      no: { initial: '', label: 'NO' },
      sessionCd: { initial: '', label: '세션코드' },
      tbmTitle: { initial: '', label: '주제' },
      tbmDate: { initial: '', label: '일자' },
      startDt: { initial: '', label: '시작' },
      endDt: { initial: '', label: '종료' },
      totalElapsedTime: { initial: '', label: '실시 시간(분)' },
      tbmAddress: { initial: '', label: '장소' },
      userList: { initial: '', label: '참석 인원' },
      userCnt: { initial: 0, label: '총원' },
      hostNm: { initial: '', label: '강사' },
      entryPath: { initial: '', label: '회의사진' },
      meetPath: { initial: '', label: 'TBM 회의 자료' },
    },
    modal: {
      no: { initial: '', label: 'NO' },
      sessionCd: { initial: '', label: '세션코드' },
      depNm1: { initial: '', label: '본부' },
      depNm2: { initial: '', label: '부서' },
      depNm3: { initial: '', label: '팀' },
      depNm4: { initial: '', label: '파트' },
      rank: { initial: '', label: '직위' },
      userNm: { initial: '', label: '참석자명' },
    },
  },

  mapper: {
    search1: {
      Year: (_, context) => Commons.EncryptAES(context.search?.year ?? ''),
      Month: (_, context) => Commons.EncryptAES(context.search?.month ?? ''),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
    },
    search2: {
      SessionCd: (_, context) =>
        encryptWithDebug('search2.SessionCd', context.sessionCd || ''),
    },

    save1: {
      SessionCd: (row) => Commons.EncryptAES(row.sessionCd || ''),
      TbmTitle: (row) => Commons.EncryptAES(row.tbmTitle || ''),
      TbmAddress: (row) => Commons.EncryptAES(row.tbmAddress || ''),
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      SessionCd: (row) => Commons.EncryptAES(row.sessionCd || ''),
    },
  },
};
